import { MeetingPedagogyUserData } from "../interfaces/pedagogy";

export interface PedagogyExtraUserData {
  late: boolean;
  report: boolean;
  notify?: boolean;
};

export const pedagogyExtraUserDataToString = (data: PedagogyExtraUserData) => {
  return `${data.late};${data.report};${data.notify ?? false}`;
};

export const pedagogyExtraUserDataFromString = (data?: string): PedagogyExtraUserData => {
  const defaultLate: PedagogyExtraUserData["late"] = true;
  const defaultReport: PedagogyExtraUserData["report"] = true;
  const defaultNotify: PedagogyExtraUserData["notify"] = false;

  if (!data?.includes(";")) {
    return { late: defaultLate, report: defaultReport, notify: defaultNotify };
  }
  const [late, report, notify] = data.split(";");
  const validLate = late === "true";
  const validReport = report === "true";
  const validNotify = notify === "true";

  return {
    late: validLate,
    report: validReport,
    notify: validNotify
  };
};

export const hasBadBehaviors = (u: MeetingPedagogyUserData) => {
  return u.badBehaviors?.hasBadNetwork || u.badBehaviors?.hasNoCamera || u.badBehaviors?.isNotAttentive;
}